export default __webpack_public_path__ + "static/media/laptop2.ca9b732e.jpg";